<template>
  <div class="recruit">
    <div class="position-relative jp-column">
      <el-image :src="mainBg" class="w-100 title-bg"></el-image>
      <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">Opportunities</h4>
      <h1 class="jp-title">{{$t('recruit.title')}}</h1>
    </div>
    <section>
      <div class="jp-line"></div>
      <div class="jp-column">
        <span class="title">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('recruit.info')}}</span>
        </span>
        <span class="en-common-title">Recruitment position</span>
        <div class="jp-content-card">
          <el-collapse v-model="activeNames">
            <el-collapse-item :name="index" v-for="(job, index) in jobList" :key="index">
              <template slot="title">
                <div class="job-title">
                  <h3>{{job.title}}</h3>
                  <div class="d-flex align-center occupation">
                    <span>{{job.workplace}}</span>
                    <div class="line"></div>
                    <span>{{$t('recruit.number')}}: {{job.number}}</span>
                    <div class="line"></div>
                    <span>{{job.createTime}}</span>
                  </div>
                </div>
              </template>
              <div class="job-detail">
                <div class="occupation">
                  <el-table :data="job.tableData">
                    <el-table-column
                      prop="level"
                      :label="$t('recruit.rank')">
                    </el-table-column>
                    <el-table-column
                      prop="numberOfManagers"
                      :label="$t('recruit.numberPeople')">
                    </el-table-column>
                    <el-table-column
                      prop="department"
                      :label="$t('recruit.numberManagers')">
                    </el-table-column>
                    <el-table-column
                      prop="supervisor"
                      :label="$t('recruit.supervisor')">
                    </el-table-column>
                    <!-- <el-table-column
                      prop="arrivalTime"
                      :label="$t('recruit.arriveTime')">
                    </el-table-column> -->
                  </el-table>
                </div>
                <p v-html="job.content"></p>
              </div>
              <div class="text-left mt-3">
                <el-button type="primary" class="px-5">
                  <a href="mailto:hr@acti-institute.com">{{$t('recruit.applyNow')}}</a>
                </el-button>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getPublishJobs } from '@/api/websiteApi';
import dateFormat from '@/filters/formatTime';
import mainBg from '@/assets/img/join_bg.png';
export default {
  name: 'recruit',
  data () {
    return {
      mainBg: mainBg,
      activeNames: [],
      jobList: []
    }
  },
  watch: {
    '$i18n.locale'(val) {
      this.tabLang(val);
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getPublishJobs().then(res => {
        _.forEach(res, item => {
          item.createTime = dateFormat.formatDate(new Date(item.createTime), 'yyyy-MM-dd');
        });
        this.jobList = res;
        this.tabLang(this.$i18n.locale)
      })
    },
    tabLang(val) {
      _.forEach(this.jobList, item => {
        item.tableData = [];
        if (val === 'cn') {
          item.title = item.titleZh;
          item.content = item.contentZh;
          item.workplace = item.workplaceZh;
          item.tableData.push({
            level: item.levelZh,
            numberOfManagers: item.numberOfManagersZh,
            department: item.departmentZh,
            supervisor: item.supervisorZh,
            arrivalTime: item.arrivalTime,
          });
        }if (val === 'en') {
          item.title = item.titleEn;
          item.content = item.contentEn;
          item.workplace = item.workplaceEn;
          item.tableData.push({
            level: item.levelEn,
            numberOfManagers: item.numberOfManagersEn,
            department: item.departmentEn,
            supervisor: item.supervisorEn,
            arrivalTime: item.arrivalTime,
          });
        }if (val === 'jp') {
          item.title = item.titleJa;
          item.content = item.contentJa;
          item.workplace = item.workplaceJa;
          item.tableData.push({
            level: item.levelJa,
            numberOfManagers: item.numberOfManagersJa,
            department: item.departmentJa,
            supervisor: item.supervisorJa,
            arrivalTime: item.arrivalTime,
          });
        }
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

section {
  h2 {
    font-size: 2rem;
  }
  .job-title {
    h3 {
      color: #0a74c2;
      text-align: left;
    }
    span {
      padding-right: 8px;
    }
    .line {
      display: block;
      height: 8px;
      background: #979797;
      width: 1px;
      margin-right: 8px;
    }
  }
  .occupation {
    font-size: 13px;
    margin-bottom: 16px;
  }
  .job-detail {
    text-align: left;
    line-height: 36px;
  }
}

@media (max-width: 768px){
  
}
</style>



// WEBPACK FOOTER //
// src/view/recruit.vue